<template>
  <div class="mt-10">
    <h1 class="section__headline">Ofertas</h1>
    <!--begin::Carta-->
    <v-container>
      <v-row class="justify-content-center">
        <div class="col-xxl-8 order-2 order-xxl-1">
          <v-card flat class="card card-custom card-stretch gutter-b">
            <v-card-title class="font-weight-bolder text-dark table__header">
              <div>Listado de ofertas</div>
            </v-card-title>
            <div class="card-body pt-0 pb-3">
              <div>
                <v-text-field
                  color="#FF8593"
                  label="Filtro"
                  required
                  @keyup="applyFilter"
                ></v-text-field>
              </div>
              <div class="text-right">
                <router-link :to="`/dealPage`">
                  <v-btn class="boton font-14 px-9 py-4 my-3">
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    CREAR OFERTA
                  </v-btn>
                </router-link>
              </div>
            </div>
          </v-card>
        </div>
      </v-row>
      <v-row>
        <div class="col-xxl-12 order-xxl-1 pt-6">
          <DealsTable :deals="filteredList" :title="'Activos'" />
        </div>
      </v-row>
    </v-container>
    <v-snackbar top :timeout="4000" v-model="snackbar.show" color="#4CAF50">
      <div class="snackbar">
        {{ snackbar.text }}
        <v-btn color="black" text @click="snackbar.show = false">
          Close
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { GET_DEALS_BY_OWNER_ID } from "@/core/services/store/deals.module";
import { GET_PRODUCTS_BY_OWNER_ID } from "@/core/services/store/products.module";
import DealsTable from "@/components/ofertas/DealsTable";
// import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";

export default {
  name: "Ofertas",
  components: {
    DealsTable,
  },
  data() {
    return {
      filteredList: null,
      snackbar: {
        show: false,
        text: "",
      },
    };
  },
  mounted() {
          this.$store.dispatch(
        GET_PRODUCTS_BY_OWNER_ID,
        this.$store.state.auth.user.seller._id
      );
    if (this.$route.query.status)
      this.showSnackbar("Producto actualizado con éxito!!  👏 👏 👏");
    this.$store
      .dispatch(GET_DEALS_BY_OWNER_ID, this.$store.state.auth.user.seller._id)
      .then(() => (this.filteredList = this.deals));
  },
  computed: {
    ...mapState({
      deals: (state) => state.deals.items,
      isFetching: (state) => state.deals.isFetching,
    }),
  },
  methods: {
    showSnackbar(msg) {
      this.snackbar.text = msg;
      this.snackbar.show = true;
    },
    applyFilter(e) {
      if (e.target.value.length === 0) {
        this.filteredList = this.deals;
      } else {
        this.filteredList = this.deals.filter((item) => {
          return item.name.toUpperCase().includes(e.target.value.toUpperCase());
          // item.name.toUpperCase().contains(e.target.value)
        });
      }
    },
  },
};
</script>
<style>
.timeline-item {
  min-height: 28px !important;
}
</style>
